module.exports = __webpack_public_path__ + "assets/img/jd1.c3657316.jpg";